module.exports = __webpack_public_path__ + "img/horizontal_4_6_r_pp13_9005.b609fa73.png";